import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@dotapps/ui';
import '@dotapps/ui/styles.css';
import { setAssetResolver } from '@dotapps/documents';
import { assetUrl } from './lib/api';
import { App } from './app/App';
import { AuthProvider } from './app/auth';
import { TenantProvider } from './app/tenant';

// logos dos documentos vêm da API
setAssetResolver(assetUrl);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true },
  },
});

/*
 * Ordem dos provedores: avisos → dados → identidade do cliente → sessão → rotas.
 * As janelas (DialogProvider) ficam dentro das rotas (ver App.tsx).
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <QueryClientProvider client={queryClient}>
        <TenantProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </TenantProvider>
      </QueryClientProvider>
    </ToastProvider>
  </StrictMode>,
);
